<template>
  <table class="table table-borderless table-align table-h51">
    <thead>
      <tr>
        <th>ID</th>
        <th>Conta</th>
        <th>Placa</th>
        <th>CNPJ</th>
        <th>Tipo</th>
        <th>Status</th>
        <th>Valor</th>
        <th>Valor a pagar</th>
        <th>Órgão consultado</th>
        <th>Vencimento</th>
        <th>Status da análise</th>
        <th>Criado em</th>
        <th>Atualizado em</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="fee in feeHistories" :key="fee.id">
        <td>{{ fee.id }}</td>
        <td>{{ getAccountName(fee) }}</td>
        <td>{{ fee.plate }}</td>
        <td>{{ fee.cnpj | cnpj }}</td>
        <td>{{ fee.kind }}</td>
        <td>{{ fee.status | statusFee }}</td>
        <td>{{ fee.valueCents | price }}</td>
        <td>{{ fee.finalValueCents | price }}</td>
        <td>{{ fee.consultedAuthority }}</td>
        <td>{{ fee.expiredAt | date }}</td>
        <td>{{ fee.analysisStatus | analysisStatus }}</td>
        <td>{{ fee.createdAt | datetime }}</td>
        <td>{{ fee.updatedAt | datetime }}</td>
        <td>

          <div class="btn-group">
            <router-link
              v-if="linkRequest"
              :to="`/admin/maestro/requests/${fee.requestId}`"
              class="btn btn-outline"
            >
              Requisição
            </router-link>

            <router-link
              v-if="linkFee && fee.feeId"
              :to="`/admin/maestro/fees/${fee.feeId}`"
              class="btn btn-outline"
            >
              Taxa
            </router-link>

            <router-link
              :to="`/admin/maestro/fee_histories/${fee.id}`"
              class="btn btn-outline"
            >
              Ver
            </router-link>
          </div>
        </td>
      </tr>
      </tbody>
  </table>
</template>

<script>
import { Translate } from '@/services/Translate'

export default {
  filters: {
    statusFee(status) {
      return Translate(`fee.${status}`)
    },
    analysisStatus(status) {
      return {
        not_analyzed: 'Não analisado',
        analyzing: 'Em análise',
        analyzed: 'Analisado',
      }[status]
    }
  },
  inject: ['getAccountName'],
  name: 'Table',
  props: {
    feeHistories: { required: true, type: Array },
    linkRequest: { default: false, type: Boolean },
    linkFee: { default: false, type: Boolean },
  }
}

</script>

<style scoped>

</style>